import Tippy from '@tippyjs/react';
import { type Placement } from 'tippy.js';
import Icon from '../Icon/Icon';

interface TooltipProps {
    content: string;
    placement?: Placement;
}


const Tooltip = ({ content, placement='auto' }: TooltipProps): JSX.Element => {
    return (
        <span className="tooltip">
            <Tippy
                interactive={true} arrow={true} placement={placement} content={content} aria={{ expanded: false }} theme="fred-hollows"
            >
                { /** Wrap the Icon component in a span to fix Tippy's issue with wrapping a functional component */ }
                <span>
                    <Icon icon={'error'} />
                </span>
            </Tippy>
        </span>
    );
};

export default Tooltip;
